<template>
	<el-dialog title="采购单据" :visible.sync="dialogTableVisible" width="55%">
		<el-row class="border-bottom padding">
			<el-col>
				<span>ID：{{ sondata.orderId }}</span>
				<span style="margin-left:20px;"
					>订单号：{{ sondata.amazonOrderId }}</span
				>
			</el-col>
			<div
				class="product"
				v-for="(item, index) in sondata.productInfos"
				:key="index"
			>
				<el-col :span="3">
					<div class="demo-image__preview">
						<el-image
							:src="item.imageUrl"
							:preview-src-list="[item.imageUrl]"
						>
						</el-image>
					</div>
				</el-col>
				<el-col :span="17">
					<el-col class="line-height" :span="24">
						<a
							target="_blank"
							class="linkto"
							:href="item.sourceLink"
							>{{ item.title }}</a
						>
					</el-col>
					<el-col class="line-height" :span="17"
						>SKU：{{ item.sku }}</el-col
					>
					<el-col class="line-height" :span="6"
						>数量：{{ item.quantityOrdered }}</el-col
					>
					<!-- <el-col class="line-height" :span="23">订单金额：-Amazon佣金：=到账：-采购价：+运费：=利润：</el-col> -->
				</el-col>
				<el-col :span="3" :offset="1">
					<el-button type="primary" @click="Sourcesupply(item.sku)"
						>查看货源</el-button
					>
				</el-col>
			</div>
			<div>采购要求：{{ sondata.purchaseDemand }}</div>
		</el-row>

		<div>
			<el-row class="border-bottom padding">
				<el-col :span="25"
					>采购单据号：{{ this.obj.purchaseNumber }}</el-col
				>

				<el-col :span="25">
					<el-row>
						<el-col class="padding" :span="20">
							<el-input v-model="this.obj.purchaseModel" disabled>
								<template slot="prepend">
									<el-tooltip
										content="完整描述海逊仓库核对的细节，海逊仓库将按照此详情核对"
										placement="top"
									>
										<el-button>海逊仓库核对详情:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col class="padding" :span="5">
							<el-input v-model="this.obj.purchasePrice" disabled>
								<template slot="prepend">采购价:</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="5">
							<el-input v-model="this.obj.rebatePrice" disabled>
								<template slot="prepend">
									<el-tooltip
										content="购买后,卖家返回的佣金"
										placement="top"
									>
										<el-button>返佣:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="5">
							<el-input v-model="this.obj.actualRefund" disabled>
								<template slot="prepend">
									<el-tooltip
										content="采购平台退回的钱"
										placement="top"
									>
										<el-button>实际退款:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>

						<el-col class="padding" :span="5">
							<el-input v-model="this.obj.otherPrice" disabled>
								<template slot="prepend">
									<el-tooltip
										content="采购员给运营实际退回的钱"
										placement="top"
									>
										<el-button>退款费用:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col class="padding" :span="5">
							<el-input
								v-model="this.obj.purchaseTypeCode"
								disabled
							>
								<template slot="prepend">类型:</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="5">
							<el-input
								v-model="this.obj.purchaseQuantity"
								disabled
							>
								<template slot="prepend">采购数量</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="5">
							<el-input
								v-model="this.obj.logisticsCompany"
								disabled
							>
								<template slot="prepend">物流公司</template>
							</el-input>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="padding" :span="20">
							<el-input
								v-model.trim="this.obj.internalConveyNumber"
								disabled
							>
								<template slot="prepend">运单号码:</template>
							</el-input>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="padding" :span="20">
							<el-input v-model="this.obj.remark" disabled>
								<template slot="prepend">
									<el-tooltip
										content="填写对应的采购平台的订单号，方便补充运单号，此备注仅自己可见"
										placement="top"
									>
										<el-button>采购备注:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>
					</el-row>
				</el-col>
				<el-col :span="4">
					<el-col class="padding">
						<el-button type="primary" @click="Editor"
							>编辑</el-button
						>
					</el-col>
				</el-col>
			</el-row>
		</div>

		<el-tabs type="border-card">
			<el-tab-pane label="操作日志">
				<el-timeline>
					<el-timeline-item
						v-for="(activity, index) in activities"
						:key="index"
						:timestamp="activity.createTime"
					>
						{{ activity.operateName }}
					</el-timeline-item>
				</el-timeline>
			</el-tab-pane>
			<el-tab-pane label="采购备忘录">
				<div style="display:flex;width:100%;">
					<el-button type="primary" @click="Themomo = true"
						>添加备忘录</el-button
					>
				</div>

				<div class="borbuttom" v-for="item in this.momoList">
					<div
						style="display: flex;justify-content: left;margin-top:15px;"
					>
						<p style="width:150px;">{{ item.roleUserName }}:</p>
						<div style="margin-top: 11px;">
							<el-image
								class="voucher"
								style="width: 30px; height: 30px"
								:src="item.repayImage.url"
								:preview-src-list="
									item.repayImage.repayCredentialsList
								"
							>
								<div slot="error" class="image-slot">
									<img
										src="../../../assets/imags/暂无图片.png"
										alt=""
										style="width:30px;height:25px;"
									/>
								</div>
							</el-image>
						</div>
						<p style="width:100%;margin-left:30px;">
							{{ item.remarkContent }}
						</p>
					</div>
					<div style="margin-top:10px;height:30px;">
						<span>采购:</span>
						<el-tag
							style="margin-left:10px;border:0;"
							v-for="tag in item.purchaseMarkItems"
							:color="tag.itemName"
							:key="tag.id"
							effect="dark"
							size="mini"
							:type="tag.type"
						>
							{{ tag.itemTypeName }}
						</el-tag>
					</div>
					<div style="height:22px;">
						<span
							style="float:right;color:#409eff;cursor: pointer;"
							v-if="item.remarkStatus == 1"
							@click="OpenToDealWith(item)"
							>待处理</span
						>
						<span style="float:right;" v-if="item.remarkStatus == 2"
							>已处理</span
						>
						<span style="float:right;" v-if="item.remarkStatus == 3"
							>已完结</span
						>
						<span style="float:right;margin-right:20px;">{{
							item.createTime
						}}</span>
					</div>
				</div>
			</el-tab-pane>
			<el-dialog
				width="30%"
				title="添加备忘录"
				:visible.sync="Themomo"
				append-to-body
			>
				<div>
					<el-dropdown trigger="click" @command="CGTagsChange">
						<el-button type="primary">
							采购状态标记<i
								class="el-icon-arrow-down el-icon--right"
							></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<div v-for="item in this.colorList1">
								<el-dropdown-item :command="item">{{
									item.itemTypeName
								}}</el-dropdown-item>
							</div>
						</el-dropdown-menu>
					</el-dropdown>

					<el-tag
						v-for="(tag, index) in CGtags"
						style="margin-left:5px;border:0;"
						@close="CGhandleClose(tag, index)"
						:color="tag.itemName"
						:key="tag.id"
						closable
						effect="dark"
						size="small"
						:type="tag.type"
					>
						{{ tag.itemTypeName }}
					</el-tag>
				</div>
				<div style="margin-top:15px;">
					<el-upload
						ref="upload"
						:action="action"
						list-type="picture-card"
						:on-success="handleAvatarSuccess"
						:on-preview="handlePictureCardPreview"
						:on-remove="handleRemove"
						:headers="customHeaders"
					>
						<i class="el-icon-plus" style="color: #0724ef;"></i>
					</el-upload>
					<el-dialog :visible.sync="dialogVisible" append-to-body>
						<img width="100%" :src="dialogImageUrl" alt />
					</el-dialog>
				</div>
				<div style="margin-top:20px;">
					<el-input
						type="textarea"
						:autosize="{ minRows: 4, maxRows: 10 }"
						placeholder="请输入内容"
						v-model="textarea1"
					>
					</el-input>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="Themomo = false">取 消</el-button>
					<el-button type="primary" @click="AddMomo">添加</el-button>
				</div>
			</el-dialog>
		</el-tabs>

		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogTableVisible = false">取 消</el-button>
			<el-button type="primary" @click="dialogTableVisible = false"
				>提 交</el-button
			>
		</div>

		<!-- 编辑采购单 -->
		<el-dialog
			width="54%"
			top="30vh"
			title="采购编辑"
			:visible.sync="innerVisible"
			append-to-body
		>
			<el-row class="border-bottom padding">
				<el-col :span="25">采购单据号：{{ purchaseNumber }}</el-col>

				<el-col :span="25">
					<el-row>
						<el-col class="padding" :span="20">
							<el-input
								v-model="purchaseModel"
								:disabled="isDisabled"
							>
								<template slot="prepend">
									<el-tooltip
										:content="isContens"
										placement="top"
									>
										<el-button>海逊仓库核对详情:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col class="padding" :span="5">
							<el-input v-model="purchasePrice">
								<template slot="prepend">采购价:</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="5">
							<el-input v-model="rebatePrice">
								<template slot="prepend">
									<el-tooltip
										content="购买后,卖家返回的佣金"
										placement="top"
									>
										<el-button>返佣:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="5">
							<el-input v-model="actualRefund">
								<template slot="prepend">实际退款:</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="5">
							<el-input v-model="otherPrice">
								<template slot="prepend">退款费用:</template>
							</el-input>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col class="padding" :span="5">
							<span class="leix">类型:</span>
							<el-select
								v-model="purchaseTypeCode"
								placeholder="请选择"
								style="width: 77%;"
								@change="shopChange"
								class="logistics"
							>
								<el-option
									v-for="item in selectType"
									:key="item.itemTypeId"
									:label="item.itemTypeName"
									:value="item.itemTypeName"
								></el-option>
							</el-select>
						</el-col>
						<el-col class="padding" :span="5">
							<el-input v-model="purchaseQuantity" disabled>
								<template slot="prepend">采购数量</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="5">
							<!-- <el-input v-model="logisticsCompany">
                                <template slot="prepend">物流公司</template>
                            </el-input> -->
							<span class="leix">物流公司:</span>
							<el-tooltip
								class="item"
								effect="dark"
								:content="isContent"
								placement="top-start"
							>
								<el-select
									:disabled="isDisabled"
									v-model="logisticsCompany"
									value-key="id"
									@change="SelectTrack17Logistics"
									filterable
									clearable
									placeholder="请选择"
									style="width: 57%;"
									class="logistics"
								>
									<el-option
										v-for="item in Track17Logistics"
										:key="item.id"
										:label="item.nameCn"
										:value="item"
									>
									</el-option>
								</el-select>
							</el-tooltip>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="padding" :span="20">
							<el-tooltip
								class="item"
								effect="dark"
								:content="isContent"
								placement="top-start"
							>
								<el-input
									v-model.trim="internalConveyNumber" onkeyup="value=value.replace(/[^\x00-\xff]/g, '')"
									:disabled="isDisabled"
								>
									<template slot="prepend"
										>运单号码:</template
									>
								</el-input>
							</el-tooltip>
						</el-col>
					</el-row>
					<el-row :gutter="20" v-show="internalConveyNumber">
						<el-col :span="6" :offset="0">
							<strong>包裹总计包含：</strong>
							<el-input-number v-model="estimatedQuantity" size="small" :min="1" :step="1">
							</el-input-number>
						</el-col>
						<el-col :span="12" :offset="0">
							<strong>该单据使用商品：</strong>
							<el-input-number v-model="useQuantity" size="small" :min="1" :step="1">
							</el-input-number>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="padding" :span="20">
							<el-input v-model="remark">
								<template slot="prepend">
									<el-tooltip
										content="填写对应的采购平台的订单号，方便补充运单号，此备注仅自己可见"
										placement="top"
									>
										<el-button>采购备注:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>
					</el-row>
				</el-col>
			</el-row>

			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="Purchaseb()">保存</el-button>
				<el-button @click="innerVisible = false">取消</el-button>
			</div>
		</el-dialog>

		<el-dialog
			title="货源链接"
			:visible.sync="dialogFormVisible"
			append-to-body
			width="35%"
		>
			<el-form>
				<el-form-item label>
					<el-row v-for="(item, index) in blue_point" :key="index">
						<el-col :span="22" style="position: relative;">
							<el-input
								placeholder="请输入内容"
								v-model="item.value"
								style="padding: 5px 0 0 0;"
							>
								<el-button
									slot="append"
									@click="handleURL(item.value)"
									>访问链接</el-button
								>
							</el-input>
						</el-col>
						<el-col :span="2">
							<el-button
								type="danger"
								@click="edit_blue_del(item, index)"
								icon="el-icon-close"
							></el-button>
						</el-col>
					</el-row>
					<span style="color:#F56C6C"
						>此链接记录货源链接，可填写1-5条，非必填。</span
					>
				</el-form-item>
			</el-form>
			<el-button type="primary" @click="edit_blue_point"
				>增加一条记录</el-button
			>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="handleTure">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog
			width="40%"
			title="处理"
			:visible.sync="ToDealWith"
			append-to-body
		>
			<div class="headTag">
				<div style="margin-top:15px;">
					<span>采购状态标记：</span>
					<el-tag
						v-for="(tag, index) in this.openWithCGTags"
						style="margin-left:5px;border:0;"
						@close="delCGTags(tag, index)"
						:color="tag.itemName"
						:key="tag.id"
						closable
						effect="dark"
						size="small"
						:type="tag.type"
					>
						{{ tag.itemTypeName }}
					</el-tag>
				</div>
			</div>

			<div style="margin-top:15px;">
				<el-upload
					ref="upload"
					:action="action"
					list-type="picture-card"
					:on-success="handleAvatarSuccess2"
					:on-preview="handlePictureCardPreview2"
					:on-remove="handleRemove2"
					:headers="customHeaders"
				>
					<i class="el-icon-plus" style="color: #0724ef;"></i>
				</el-upload>
				<el-dialog :visible.sync="dialogVisible2" append-to-body>
					<img width="100%" :src="dialogImageUrl2" alt />
				</el-dialog>
			</div>
			<div style="margin-top:20px;">
				<el-input
					type="textarea"
					:autosize="{ minRows: 4, maxRows: 10 }"
					placeholder="请输入内容"
					v-model="textarea2"
				>
				</el-input>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="SubEnd">提交并完结</el-button>
				<el-button type="primary" @click="SubNoEnd"
					>提交未完结</el-button
				>
			</div>
		</el-dialog>
	</el-dialog>
</template>

<script>
import Remarks from '../Remarks'
import { ajaxPost, Baseurl } from '../../../api/api/api'
export default {
	name: 'PurchasingDocuments',
	components: {
		Remarks,
	},
	data() {
		return {
			sondata: '',
			arr: '',
			str: '',
			obj: '',
			innerVisible: false,
			amazonOrderId: '',
			companyId: '',
			purchasePrice: '', //采购价
			purchaseModel: '', //采购详情
			rebatePrice: '', //返佣
			otherPrice: '', //退款费用
			actualRefund: '', //实际退款
			purchaseTypeCode: '', //采购类型
			remark: '', //采购备注
			internalConveyNumber: '', //运单号码
			logisticsCompany: '', //物流公司
			companyCode: '', //物流公司编码

			purchasePrice1: '', //采购价
			purchaseQuantity: '', //采购数量
			purchaseModel1: '', //采购详情
			rebatePrice1: '', //返佣
			otherPrice1: '', //退款费用
			purchaseTypeCode1: '', //采购类型
			remark1: '', //采购备注
			internalConveyNumber1: '', //运单号码
			logisticsCompany1: '', //物流公司

			purchaseNumber: '', //采购单据号
			selectType: '',
			id: '',
			type: '',
			type1: '',
			dialogTableVisible: false,
			purchaseDemandId: '',

			dialogFormVisible: false,
			blue_point: [],
			activities: [],

			momoList: [],
			Themomo: false,
			ToDealWith: false,

			action: Baseurl + 'imageController/uploadImage',
			customHeaders: { token: localStorage.getItem('token') },
			imageData: [],
			imageData1: [],
			imageData2: [],
			images: [],
			images1: [],
			textarea1: '',
			textarea2: '',
			dialogVisible: false,
			dialogVisible2: false,
			dialogImageUrl: '',
			dialogImageUrl2: '',
			colorList1: '',
			Logistics: [],
			Track17Logistics: [],
			CGtags: [],
			openWith: '',
			openWithCGTags: '',
			deletePurchaseMark: [],
			remarkStatusNo: '',
			isDisabled: '',
			isContent: '',
			isContens: '',
			estimatedQuantity: 1,
			useQuantity: 1,
			estimatedId: ''
		}
	},
	mounted() {},
	created() {
		this.str = JSON.parse(localStorage.getItem('role'))
		var itemCode = {
			itemCode: 'HYXUN0000001',
		}
		ajaxPost(Baseurl + 'purchaseController/selectItemList', itemCode).then(
			(res) => {
				this.selectType = res.data.data
			}
		)
	},
	watch: {
		internalConveyNumber(val) {
			this.changeInternalConveyNumber()
		}
	},
	methods: {
		init(e) {
			this.dialogTableVisible = true
			this.sondata = e
			;(this.amazonOrderId = this.sondata.amazonOrderId),
				(this.purchaseDemandId = this.sondata.purchaseDemandId)
			this.Editrendering()
			// console.log(this.sondata)
			this.Thelog()
			this.TheMemo()
			this.orderTag()
			this.LogisticsAjax()
			this.Track17LogisticsAjax()
			if (this.sondata.checkResult == 4) {
				this.isDisabled = false
				this.isContent = '请填写物流公司/运单号码'
				this.isContens =
					'完整描述海逊仓库核对的细节，海逊仓库将按照此详情核对'
			} else {
				this.isDisabled = true
				this.isContent =
					'该采购单已经入库，国内单号和物流公司不能修改！'
				this.isContens = '已经入库，不能修改！'
			}
		},
		Editor() {
			this.innerVisible = true
			var theId = { id: this.sondata.id }
			ajaxPost(
				Baseurl + '/purchaseController/selectPurchaseById',
				theId
			).then((res) => {
				// console.log(res.data.data)
				this.purchaseNumber = res.data.data.purchaseNumber
				this.purchasePrice = res.data.data.purchasePrice
				this.purchaseModel = res.data.data.purchaseModel
				this.rebatePrice = res.data.data.rebatePrice
				this.otherPrice = res.data.data.otherPrice
				this.actualRefund = res.data.data.actualRefund
				this.purchaseTypeCode = res.data.data.purchaseTypeCode
				this.remark = res.data.data.remark
				this.internalConveyNumber = res.data.data.internalConveyNumber
				this.purchaseQuantity = res.data.data.purchaseQuantity
				this.logisticsCompany = res.data.data.logisticsCompany
			})
		},
		orderTag() {
			var obj = { itemCode: 'HYXUN0000013' }
			ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.colorList1 = res.data.data
						this.sortByKey(this.colorList1, 'itemTypeIdInteger')
					}
				}
			)
		},
		Thelog() {
			ajaxPost(Baseurl + 'logisticsController/getOrderOperateLog', {
				orderId: this.sondata.orderId,
			}).then((res) => {
				if (res.data.code == 200) {
					this.activities = res.data.data
					// console.log(res.data.data)
				}
			})
		},
		shopChange(value) {
			this.purchaseTypeCode = value
		},
		shopChange1(value) {
			this.purchaseTypeCode1 = value
		},
		Editrendering() {
			var orderid = {
				id: this.sondata.id,
			}
			ajaxPost(
				Baseurl + 'purchaseController/selectPurchaseById',
				orderid
			).then((res) => {
				this.obj = res.data.data
				// console.log(this.obj)
			})
		},
		Purchaseb() {
			// if(this.internalConveyNumber == ""){
			if (
				this.internalConveyNumber == '' &&
				this.logisticsCompany !== ''
			) {
				this.$message.error('物流公司和运单号码必须同时填写')
			} else if (
				this.internalConveyNumber !== '' &&
				this.logisticsCompany == ''
			) {
				this.$message.error('物流公司和运单号码必须同时填写')
			} else if (Number(this.otherPrice) > Number(this.actualRefund)) {
				this.$message.error(' 实际退款不能小于退款费用/运营退款')
			} else {
				this.SaveAjax()
			}
			// }else{
			//     var obj = {
			//         num: this.internalConveyNumber
			//     };
			//     ajaxPost(Baseurl + "conveyNumberQueryController/autoNum", obj).then(res => {
			//         // console.log(res.data);
			//         if(res.data.code == 200){
			//             this.SaveAjax()
			//         }else{
			//             this.$message.error(res.data.data)
			//         }
			//     });
			// }
		},
		SaveAjax() {
			var addproduct = {
				companyId: this.str.company_id,
				purchaseRoleId: this.str.rid,
				amazonOrderId: this.amazonOrderId,
				purchaseFrom: '1',
				id: this.sondata.id,
				internalConveyNumber: this.internalConveyNumber,
				purchasePrice: this.purchasePrice,
				rebatePrice: this.rebatePrice,
				purchaseModel: this.purchaseModel,
				logisticsCompany: this.logisticsCompany,
				purchaseTypeCode: this.purchaseTypeCode,
				remark: this.remark,
				purchaseQuantity: this.purchaseQuantity,
				otherPrice: this.otherPrice,
				actualRefund: this.actualRefund,
				queryTrackSwitch: this.sondata.queryTrackSwitch,
				companyCode: this.companyCode,
				roleId: this.str.rid,
			}
			if (this.internalConveyNumber) {
				this.$set(addproduct, 'useQuantity', this.useQuantity)
				let obj = {
					internalConveyNumber: this.internalConveyNumber,
					estimatedQuantity: this.estimatedQuantity
				}
				if (this.estimatedId) {
					this.$set(obj, 'id', this.estimatedId)
				}
				this.$set(addproduct, 'logisticsInformation', obj)
			}
			ajaxPost(
				Baseurl + '/purchaseController/updatePurchase',
				addproduct
			).then((res) => {
				this.estimatedId = ''
				this.estimatedQuantity = 1
				this.useQuantity = 1
				if (res.data.code == 200) {
					this.$message({ message: '保存成功', type: 'success' })
					// console.log(res.data.data);
					this.innerVisible = false
					// this.SavesubscribeAjax()  //快递100订阅
					this.Track17RegisterAjax(this.sondata.queryTrackSwitch)  //17track注册
					this.Editrendering()
					this.$emit('refresh')
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		SavesubscribeAjax() {
			var obj = {
				companyId: this.sondata.companyId,
				number: this.internalConveyNumber,
				company: this.logisticsCompany.logisticsCompanyCode,
			}
			ajaxPost(
				Baseurl + 'conveyNumberQueryController/subscribe',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					console.log(res.data)
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		Track17RegisterAjax(queryTrackSwitch) {
			if(queryTrackSwitch == 1){
				var obj = [{
					number: this.internalConveyNumber,
					carrier: this.companyCode,
				}]
				ajaxPost(
					Baseurl + 'track17Controller/register',
					obj
				).then((res) => {
					if (res.data.code == 200) {
						console.log(res.data);
					} else {
						this.$message.error(res.data.data)
					}
				})
			}
			
		},
		SelectTrack17Logistics(val) {
			if(val) {
				this.logisticsCompany = val.nameCn
				this.companyCode = val.key
			}
		},
		handleURL(url) {
			// alert(url);
			// console.log(url);
			window.open(url)
		},
		Sourcesupply(sku) {
			this.dialogFormVisible = true
			this.blue_point = []
			ajaxPost(Baseurl + 'productController/getProductSourceLink', {
				sku: sku,
			}).then((res) => {
				// console.log(res.data.data);
				// this.blue_point = res.data.data;
				res.data.data.map((value) => {
					this.blue_point.push({
						value: value,
						type: false,
					})
				})
				// console.log(this.blue_point);
			})
		},
		edit_blue_point(index, method) {
			if (this.blue_point.length < 5) {
				const param = {
					value: '',
					type: true,
				}
				this.blue_point.push(param)
			} else {
				this.$message('此链接记录货源链接最多5条字段')
			}
		},
		// 删除链接
		edit_blue_del(item, index) {
			this.$confirm('此操作将永久删除, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					this.blue_point.splice(index, 1)
					this.$message({
						type: 'success',
						message: '删除成功!',
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除',
					})
				})
		},
		// 确定货源
		handleTure() {
			// console.log(this.sondata.productInfos[0].sku);
			// console.log(this.blue_point);
			var arr = []
			this.blue_point.map((v) => {
				arr.push(v.value)
			})
			// console.log(arr);
			ajaxPost(Baseurl + 'productController/updateProductSourceLink', {
				sku: this.sondata.productInfos[0].sku,
				sourceLinks: arr,
			}).then((res) => {
				if (res) {
					this.$message({
						type: 'success',
						message: '设置成功!',
					})
					this.Viewsourcing(this.sondata.productInfos[0].sku)
					this.dialogFormVisible = false
				}
			})
		},
		TheMemo() {
			var obj = {
				documentId: this.sondata.id,
				remarkType: '2',
			}
			ajaxPost(Baseurl + 'orderController/selectRemarkList', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.momoList = res.data.data
					}
				}
			)
		},
		handleAvatarSuccess(file, fileList) {
			this.imageData.push(file)
		},
		handleRemove(file, fileList) {
			this.imageData = []
			for (var i = 0; i < fileList.length; i++) {
				this.imageData.push(fileList[i].response)
			}
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url
			this.dialogVisible = true
		},
		handleAvatarSuccess2(file, fileList) {
			this.imageData1.push(file)
			// console.log(this.imageData1)
		},
		handleRemove2(file, fileList) {
			this.imageData1 = []
			for (var i = 0; i < fileList.length; i++) {
				this.imageData1.push(fileList[i].response)
			}
		},
		handlePictureCardPreview2(file) {
			this.dialogImageUrl2 = file.url
			this.dialogVisible2 = true
		},
		AddMomo() {
			if (this.CGtags.length == 0 || this.CGtags == []) {
				this.$message.error('请添加采购标记！')
			} else if (this.textarea1 == '') {
				this.$message.error('请输入备忘录内容！')
			} else {
				var str = JSON.parse(localStorage.getItem('role'))
				for (var i = 0; i < this.imageData.length; i++) {
					this.images.push(this.imageData[i].data)
				}

				var obj = {
					insertType: 1,
					documentId: this.sondata.id,
					orderId: this.sondata.id,
					remarkContent: this.textarea1,
					roleId: str.rid,
					remarkImages: this.images,
					remarkType: 2,
					remarkId: '',
					remarkOrder: '',
					remarkStatus: '',
					id: '',
					purchaseMarkItems: this.CGtags,
				}
				ajaxPost(Baseurl + 'orderController/insertRemark', obj).then(
					(res) => {
						if (res.data.code == 200) {
							this.$message({
								type: 'success',
								message: '添加采购备忘录成功!',
							})
							this.$emit('refresh')
							this.TheMemo()
						} else {
							this.$message.error(res.data.data)
						}
						this.CGtags = []
						this.images = []
						this.imageData = []
						this.textarea1 = ''
					}
				)
				this.$refs.upload.clearFiles()
				this.Themomo = false
			}
		},
		CGTagsChange(val) {
			this.CGtags.push(val)
			// console.log(this.CGtags)
		},
		CGhandleClose(tag, index) {
			this.CGtags.splice(index, 1)
		},
		OpenToDealWith(val) {
			this.ToDealWith = true
			this.openWith = val
			this.openWithCGTags = JSON.parse(
				JSON.stringify(val.purchaseMarkItems)
			)
			// console.log(val)
		},
		delCGTags(val, index) {
			// console.log(val)
			this.openWithCGTags.splice(index, 1)
			this.deletePurchaseMark.push(val.itemTypeId)
			// console.log(this.openWithGNTags)
		},
		SubEnd() {
			this.remarkStatusNo = 3
			if (this.textarea2 == '') {
				this.$message.error('请输入内容！')
			} else {
				this.EndAjax()
			}
		},
		SubNoEnd() {
			this.remarkStatusNo = 2
			if (this.textarea2 == '') {
				this.$message.error('请输入内容！')
			} else {
				this.EndAjax()
			}
		},
		EndAjax() {
			var str = JSON.parse(localStorage.getItem('role'))
			for (var i = 0; i < this.imageData1.length; i++) {
				this.images1.push(this.imageData1[i].data)
			}

			var obj = {
				insertType: 2,
				documentId: this.sondata.id,
				orderId: this.sondata.id,
				remarkContent: this.textarea2,
				roleId: str.rid,
				remarkImages: this.images1,
				remarkType: 2,
				remarkId: this.openWith.remarkId,
				remarkOrder: this.openWith.remarkOrder,
				remarkStatus: this.remarkStatusNo,
				id: this.openWith.id,
				purchaseMarkItems: this.openWithCGTags,
				deletePurchaseMark: this.deletePurchaseMark,
			}
			ajaxPost(Baseurl + 'orderController/insertRemark', obj).then(
				(res) => {
					if (res.data.code == 200) {
						if (this.remarkStatusNo == 3) {
							this.$message({
								type: 'success',
								message: '提交并完结成功!',
							})
						} else if (this.remarkStatusNo == 2) {
							this.$message({
								type: 'success',
								message: '提交未完结成功!',
							})
						}
						this.TheMemo()
						this.$emit('refresh')
					} else {
						this.$message.error(res.data.data)
					}
					this.deleteChannelMark = []
					this.deletePurchaseMark = []
					this.images1 = []
					this.imageData1 = []
					this.textarea2 = ''
				}
			)
			this.$refs.upload.clearFiles()
			this.ToDealWith = false
		},
		sortByKey(array, key) {
			return array.sort(function(a, b) {
				var x = a[key]
				var y = b[key]
				return x < y ? -1 : x > y ? 1 : 0
			})
		},
		LogisticsAjax() {
			ajaxPost(
				Baseurl + 'logisticsController/getLogisticsCompanyList'
			).then((res) => {
				if (res.data.code == 200) {
					this.Logistics = res.data.data
				}
			})
		},
		Track17LogisticsAjax() {
			ajaxPost(
				Baseurl + 'logisticsController/getTrack17Carriers'
			).then((res) => {
				if (res.data.code == 200) {
					this.Track17Logistics = res.data.data
				}
			})
		},
		changeInternalConveyNumber() {
			if (this.internalConveyNumber) {
				var obj = {
					internalConveyNumber: this.internalConveyNumber
				}
				ajaxPost(
					Baseurl + 'logisticsInformationController/selectLogisticsInformation',
					obj
				).then((res) => {
					if (res.data.code == 200) {
						if (res.data.data && res.data.data.estimatedQuantity) {
							this.estimatedId = res.data.data.id
							this.estimatedQuantity = Number(res.data.data.estimatedQuantity)
						}
					} else {
						this.$message.error(res.data.data || res.data.message)
					}
				})
			}
		}
	}
}
</script>

<style lang="scss" scoped>
/deep/ {
	.el-dialog__body {
		padding: 13px 20px;
	}
	.el-input-group__append,
	.el-input-group__prepend {
		padding: 0 10px !important;
	}
	.layout .layout-section ::-webkit-scrollbar {
		width: 10px;
		height: 10px;
		background-color: #b71e1e;
	}
	.logistics .el-input__inner {
		border-radius: 0px 4px 4px 0px !important;
	}
}
.line-height {
	line-height: 35px;
}
.padding {
	padding: 10px 0;
}
img {
	width: 100%;
	height: 100%;
}
.product {
	margin-top: 25px;
	width: 100%;
	height: 160px;
}
.linkto {
	color: #409eff;
}
.leix {
	background-color: #f5f7fa;
	line-height: 30px;
	padding: 5px;
	border-left: 1px solid #e4e7ed;
	border-bottom: 1px solid #e4e7ed;
	border-top: 1px solid #e4e7ed;
	color: #909399;
	border-radius: 4px 0px 0px 4px;
}
.borbuttom {
	width: 100%;
	border-bottom: 1px solid #e4e7ed;
}
.borbuttom p {
	line-height: 50px;
}
</style>
